// TopNavbar.jsx
import React, { useState } from "react";
import { ChevronDown, Search, Bell } from "lucide-react";
import { useMsal } from "@azure/msal-react";
import { setAuthToken } from "../api";

export default function TopNavbar({
  user,
  notifications = 0,
  toggleSidebar,
  logout,
  title,
  subtitle,
  showSearch,
  style
}) {
  const { instance } = useMsal();
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const getInitials = (name) => {
    if (!name) return "U";
    // Filter out "undefined" or empty parts
    const parts = name.split(" ").filter(p => p && p.toLowerCase() !== "undefined");
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (name || "U").substring(0, 2).toUpperCase();
  };

  return (
    <div className="tms-top-nav" style={style}>
      {/* Hamburger */}
      <div className="hamburger" onClick={toggleSidebar}>
        ☰
      </div>

      <div className="tms-top-nav-left" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '2px', marginLeft: '12px', flex: 1 }}>
        {title && <h1 style={{ fontSize: '18px', fontWeight: 700, margin: 0, color: '#0f172a' }}>{title}</h1>}
        {subtitle && <p style={{ fontSize: '12px', margin: 0, color: '#64748b' }}>{subtitle}</p>}
      </div>

      <div className="tms-top-nav-center" style={{ flex: 1, display: 'flex', justifyContent: 'center', margin: '0 24px' }}>
      </div>

      <div className="tms-top-nav-right" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <div
          className="tms-profile-dropdown-wrapper"
          onMouseEnter={() => setShowProfileDropdown(true)}
          onMouseLeave={() => setShowProfileDropdown(false)}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div className="tms-header-avatar" style={{ width: '32px', height: '32px', fontSize: '12px' }}>
              {user ? getInitials(user.name || user.empId) : "SN"}
            </div>
          </div>

          {showProfileDropdown && (
            <div className="tms-profile-dropdown">
              <div className="tms-profile-dropdown-header">
                <div className="tms-profile-dropdown-avatar">
                  {user ? getInitials(user.name || user.empId) : "SN"}
                </div>
                <div className="tms-profile-dropdown-info">
                  <div className="tms-profile-dropdown-name">
                    {user?.name?.toLowerCase().includes("undefined") ? (user?.name.split(" ")[0] || "User") : (user?.name || "User")}
                  </div>
                  <div className="tms-profile-dropdown-empid">{user?.empId}</div>
                  <div className="tms-profile-dropdown-email">{user?.email}</div>
                </div>
              </div>

              <div className="tms-profile-dropdown-divider"></div>

              <button
                className="tms-profile-dropdown-item"
                onClick={() => {
                  logout();
                  setAuthToken(null);
                  instance.logoutRedirect({
                    postLogoutRedirectUri: "/",
                  });
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}